export default __webpack_public_path__ + "static/media/transparent_square.201e9de6.svg";